import { useState, MouseEvent } from "react";
import classNames from "classnames";
import { IconButton } from "src/Components";
import { RdcGroupItemType } from ".";
import { useSearchMark } from "src/Hooks";
import { ReactComponent as StartIcon } from 'src/Themes/assets/Icon Star.svg';
import { ReactComponent as StarNotFilled } from 'src/Themes/assets/StarNotFilled.svg';
import st from "./RdcGroupItem.module.scss";

interface IRdcGroupItemProps {
	searchText: string;
	item: any;
	enableFavorite?: boolean;
	selectedIdList: Array<string>;
	onAction: ( e: MouseEvent, item: any, action: string ) => void;
	renderItemTb?: ( item: any ) => React.ReactNode;
	onGetParams: ( item: any ) => RdcGroupItemType;
};

export const RdcGroupItem: React.FC<IRdcGroupItemProps> = ( props ) => {

	const { enableFavorite = false, item, searchText, selectedIdList, 
		onAction, renderItemTb, onGetParams
	} = props;

	const { getHtml } = useSearchMark();
	const [ groupItem ] = useState<RdcGroupItemType>(onGetParams( item ));

	const onActionHandler = ( e: MouseEvent, actionName: string ) => {
		e.preventDefault();
		e.stopPropagation();
		onAction( e, item, actionName );
	};

	const recid = "textFor-" + groupItem.id;
	return (
		<div className={classNames( st.RdcGroupItem, { [st.selected]: selectedIdList.includes(groupItem.id) })} id={item.id} onClick={(e) => onActionHandler(e, "itemClick" )} >
		{
			!!enableFavorite && 
			<div className={st.RdcGroupItem__toolbar_bef}>
				<IconButton 
					outline
					onClick={ e => onActionHandler( e, "toggleFavorite" )} 
					data-tooltip-id="rdc_tooltip" 
					data-tooltip-content={ groupItem.isFavorite ? "Убрать из избранного" : "Добавить в избранное" }
				>
				{
					groupItem.isFavorite
					? <StartIcon width={24} height={24} />
					: <StarNotFilled className={st.snf} width={32} height={32} />
				}
				</IconButton>
			</div>
		}
		<span id={recid} className="body-small" dangerouslySetInnerHTML={{ __html: getHtml(groupItem.title, searchText) }} />
		{
			!!renderItemTb &&
			<div className={st.RdcGroupItem__toolbar}>
				{ renderItemTb(item) }
			</div>
		}
		</div>
	);
};
